import React,{useState,useEffect} from 'react'
import axios from 'axios'
import { genericHeaders, serviceUrl } from '../utils/apiConfig';
import NoContent from '../Icons/No-Content-Laptop.svg'  
import LeaveComponent from './LeaveComponent';
import Loader from "../Components/customComponents/customLoader"
import { useWithdrawAppliedLeaveMutation } from '../api/getLeaveTypeApi';

const ClosedLeaves = () => {

    const [leaveData,setLeaveData] = useState([]);
    const [historyData,setHistoryData] = useState([]);
    const [employees,setEmployees] = useState([]);
    const [data,setData] = useState([]);
    const [loading,setLoading] = useState(false);
    const [visibleDetails, setVisibleDetails] = useState({});
    const [withdrawAppliedLeave, {isLoading, isSuccess}] = useWithdrawAppliedLeaveMutation()

    const toggleDetailsVisibility = (id, forceValue = null) => {
      setVisibleDetails(prev => ({
        ...prev,
        [id]: forceValue !== null ? forceValue : !prev[id]
      }));
    };

    const getActiveLeaves = async () => {
        setLoading(true);
        try {
          let response = await axios.get(
            `${serviceUrl}/api/leaveTransaction/reviewedLeaveTransactions`,
            { headers: genericHeaders() });
          if (response.status === 200) {
            setData(response.data);
            setLoading(false);
          }
        } catch (err) {
          setLoading(false);
          console.error(err);
        }
    };
    const getLeaveData = async() => {
        try{
          let response = await axios.get(`${serviceUrl}/api/leaveCategory/getAllLeaveCategories`,{headers: genericHeaders()});
          if(response.status === 200){
            setLeaveData(response.data);
          }

        }catch(err){
            console.error(err)
        }
    }
    const getEmployees = async() => {
      try{
        let response = await axios.get(`${serviceUrl}/api/employee/getEmployeesList`,{headers: genericHeaders()})
        if(response.status === 200){
          setEmployees(response.data);
        }
      } catch(err){
        console.error(err);
      }
    }
    const adminWithdraw = (id)=>{
      withdrawAppliedLeave({id:id, payload:''})
    }
    useEffect(() => {
      getActiveLeaves(); 
      getLeaveData();
      getEmployees();
  }, [])
  useEffect( () => {
      if(data && leaveData){
       let newData = matchData(data,leaveData,employees);
       setHistoryData(newData);
      }
   },[data,leaveData,employees])

    useEffect(() => {
      if (historyData && historyData.length > 0) {
        const currentIds = historyData.map(item => item._id);
        setVisibleDetails(prev => {
          const newState = {};
          Object.keys(prev).forEach(id => {
            if (currentIds.includes(id)) {
              newState[id] = prev[id];
            }
          });
          return newState;
        });
      } else {
        setVisibleDetails({});
      }
    }, [historyData]);
    useEffect(()=>{
      if(isSuccess){
        getActiveLeaves();
        getLeaveData()
      }
      setLoading(isLoading);
    }, [isLoading, isSuccess])
     const matchData = (employeeLeaves, leaveData, empData) => {
      let data = [];
      if (employeeLeaves && leaveData) {
        employeeLeaves.map( (item) => {
            let matchedLeave = leaveData.find( (leave) => leave._id === item.leaveType);
            if(matchedLeave){
              item.leaveCategory = matchedLeave.leaveCategory;
            }
            let matchedEmployee = empData.find( (emp) => emp.id === item.employeeId);
            if(matchedEmployee){
             item.employeeName = matchedEmployee.name;
            }
            if(item.declinerName !== null){
              let matchedEmployee = empData.find( (emp) => emp.id === item.declinerName);
              if(matchedEmployee){
                item.declinerName = matchedEmployee.name;
              }
            }
            if(item.approverName !== null){
              let matchedEmployee = empData.find( (emp) => emp.id === item.approverName);
              if(matchedEmployee){
                item.approverName = matchedEmployee.name;
              }
            }
            item.role = "Manager"
            data.push(item);
        })
      }
      return data;
    };
  return (
    <div>
      {loading && (<Loader/>)}
      <div>
        {historyData.length > 0 ? (
          historyData.map((item) => (
            <LeaveComponent 
              key={item._id}
              data={item} 
              detailsVisible={visibleDetails[item._id] || false}
              toggleDetailsVisibility={toggleDetailsVisibility}
              adminWithdraw = {adminWithdraw}
            />
          ))
        ) : (
          <div className="mt-[15%] flex flex-col items-center justify-center">
            <img src={NoContent} />
            <p className="text-xl">
              No historical records of leave transactions are available.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ClosedLeaves